/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsUserDetails204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsUserDetails505Schema = z.any();

export const optionsUserDetailsMutationResponseSchema = z.lazy(() => optionsUserDetails204Schema);
